import React, { Component } from 'react'
import Table from "../../../../components/UI/Table/Table";
import './Table.css';
// import { tableColumns } from './constant';
import { DEFAULT_PAGE_SIZE, TABLE_COLUMNS } from '../constants';

class TableView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: this.props.tasks,
            sorted: {
                id: "name",
                desc: true
            },
            pageSize: DEFAULT_PAGE_SIZE,
            currentPageIndex: 0
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.tasks !== prevProps.tasks) {
            this.setState({
                data: this.props.tasks
            })
        }
    }

    render() {
        return (
            <Table
                data={(this.state.data.masterDataKeyList) ? this.state.data.masterDataKeyList : []}
                columns={TABLE_COLUMNS}
                defaultSorted={[
                    {
                        id: "name",
                        desc: true
                    }
                ]}
                className="PendingCasesTable"
                noDataText="No Data found"
                multiSort={false}
                pages={this.state.data.numberOfPages}
                defaultPageSize={DEFAULT_PAGE_SIZE}
                showPagination={true}
                showPaginationTop={false}
                showPaginationBottom={true}
                manual  // this would indicate that server side pagination has been enabled 
                loading={this.props.loading}
                onPageChange={(pageIndex) => { // Called when the page index is changed by the user
                    this.setState({
                        currentPageIndex: pageIndex
                    });
                    this.props.onFetchPage( pageIndex, this.state.pageSize, this.state.sorted);
                }}
                onSortedChange={(newSorted, column, shiftKey) => { // Called when a sortable column header is clicked with the column itself and if the shiftkey was held. If the column is a pivoted column, 'column' will be an array of columns
                    this.setState({
                        sorted: newSorted[0]
                    });
                    this.props.onFetchPage( 0, this.state.pageSize, newSorted[0]);
                }}
                onPageSizeChange={(pageSize, pageIndex) => {
                    this.setState({
                        pageSize: pageSize
                    })
                    this.props.onFetchPage(0, pageSize, this.state.sorted);
                }}
            />
        )
    }
}

export default TableView
